/*
 * @Author: hzm
 * @Date: 2024-01-24 14:45:00
 * @Description:
 */

//
import { appInfo } from '@/stores/appInfo';
import { getShopName } from './hinaUtils';

export * from './hinaUtils';

const hina = window.hina || {};
// 前向地址
const H_referrer = document.referrer;
// 前向域名
const H_referrer_domain = H_referrer.split('/')[2];
// 页面路径
const H_url_path = window.location.pathname;

// 登录埋点 设置用户信息
export function setUserUId(userId) {
  hina.setUserUId(userId);
}

export function setUserInfo(userInfo: {
  user_name?: string;
  zdy_user_id?: string;
  phone?: string;
  company_name?: string;
  address?: string;
  province?: string;
  city?: string;
  region?: string;
}) {
  hina.userSet(userInfo);
  userInfo.zdy_user_id && hina.setUserUId(userInfo.zdy_user_id);
}

//  登录埋点

export function loginPoint({ sign_in_type }: { sign_in_type?: 'password' | 'code' | 'wechat' }) {
  hina.track('sign_in', {
    sign_in_type,
    platform: '1',
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

//  注册埋点
export function registerPoint() {
  hina.track('register_success', {
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

// 搜索页埋点
export function searchPoint({
  search_word,
  search_result_number,
  belong_shop,
}: {
  search_word: string;
  search_result_number: number;
  belong_shop: string;
}) {
  hina.track('search_word', {
    H_url_path,
    search_word,
    search_result_number,
    belong_shop,
    H_referrer,
    H_referrer_domain,
  });
}

// 详情页埋点
export function detailPoint({
  product_sn,
  product_id,
  product_name,
  product_price,
  product_brand,
  product_brand_id,
  cate_id,
  cate_name,
  supplier_company_id,
  supplier_company_name,
  host_id,
  zone_id,
}: {
  product_sn: string;
  product_id: string;
  product_name: string;
  product_price?: number;
  product_brand?: string;
  cate_id: string;
  cate_name: string;
  product_brand_id?: string;
  supplier_company_id?: string;
  supplier_company_name?: string;
  host_id?: string;
  zone_id?: string;
}) {
  hina.track('product_detail_enter', {
    product_sn,
    product_id,
    product_name,
    product_price,
    cate_id,
    cate_name,
    product_brand_id,
    product_brand,
    supplier_company_id,
    supplier_company_name,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
    host_id,
    zone_id,
  });
}

//  确认订单埋点
export function confirmOrderPoint({
  product_id,
  product_name,
  product_price,
  product_brand,
  product_brand_id,
  cate_id,
  cate_name,
  supplier_company_id,
  supplier_company_name,
  order_id,
  order_sn,
  product_quantity,
  product_sku_id,
  product_attr,
  total_amount,
  use_points,
  freight_amount,
  pay_type,
  zone_id,
  host_id,
  order_type,
  duration_time,
  receiver_province,
  receiver_city,
  receiver_region,
  // 订单应付金额
  order_total_amount,
  // 订单实付金额
  order_pay_amount,
  // 积分抵扣金额
  order_points_amout,
  // 订单运费金额
  order_freight_amount,
  // 订单来源
  order_source,
  product_attr_str,
  // 套餐id
  package_id,
  // 订单子项状态
  status,
  order_status,
  order_item_id,
  promotion_activity_flag,
}: {
  product_id: string;
  product_name: string;
  product_price?: number;
  product_brand?: string;
  cate_id: string;
  cate_name: string;
  product_brand_id?: string;
  supplier_company_id?: string;
  supplier_company_name?: string;
  order_id?: string;
  order_sn?: string;
  product_quantity?: number;
  product_sku_id?: string;
  product_attr?: string;
  total_amount?: number;
  use_points?: number;
  freight_amount?: number;
  pay_type?: string;
  zone_id?: string;
  host_id?: string;
  order_type?: string;
  duration_time?: string;
  receiver_province?: string;
  receiver_city?: string;
  receiver_region?: string;
  order_total_amount?: number;
  order_pay_amount?: number;
  order_points_amout?: number;
  order_freight_amount?: number;
  order_source?: string;
  product_attr_str?: string;
  package_id?: string;
  status?: string;
  order_status?: string;
  order_item_id?: string;
  promotion_activity_flag?: string;
}) {
  hina.track('confirm_order', {
    product_id,
    product_name,
    product_price,
    cate_id,
    cate_name,
    product_brand_id,
    product_brand,
    supplier_company_id,
    supplier_company_name,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
    order_id,
    order_sn,
    product_quantity,
    product_sku_id,
    product_attr,
    total_amount,
    use_points,
    freight_amount,
    pay_type,
    zone_id,
    host_id,
    order_type,
    H_url_path,
    duration_time,
    receiver_province,
    receiver_city,
    receiver_region,
    order_total_amount,
    order_pay_amount,
    order_points_amout,
    order_freight_amount,
    order_source,
    product_attr_str,
    package_id,
    status,
    order_status,
    order_item_id,
    promotion_activity_flag,
  });
}

//  首页分类点击 home_cate_click
export function homeCateClickPoint({ cate_id, cate_name }: { cate_id: string; cate_name: string }) {
  hina.track('home_cate_click', {
    cate_id,
    cate_name,
    belong_shop: appInfo().pointShopName,
  });
}

// 商品详情页 加入购物车 product_add_cart
/**
 * 参数
 * belong_shop	所属商城
product_id	产品id
product_name	产品名称
cate_id	分类id
cate_name	分类名称
add_num	加购数量
product_price	产品价格
H_referrer_domain	前向域名
H_referrer	前向地址
 */
export function productAddCartPoint({
  product_id,
  product_name,
  cate_id,
  cate_name,
  add_num,
  product_price,
  product_sku_id,
  product_attr_str,
  host_id,
  zone_id,
}: {
  product_id: string;
  product_name: string;
  cate_id: string;
  cate_name: string;
  add_num: number;
  product_price: number;
  product_sku_id?: string;
  product_attr_str?: string;
  host_id: string;
  zone_id: string;
}) {
  hina.track('product_add_cart', {
    product_id,
    product_name,
    cate_id,
    cate_name,
    add_num,
    product_price,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
    product_sku_id,
    product_attr_str,
    host_id,
    zone_id,
  });
}

//  产品详情添加收藏 product_add_favorite
/**
 *  belong_shop	所属商城
product_id	产品id
product_name	产品名称
cate_id	分类id
cate_name	分类名称
H_referrer_domain	前向域名
H_referrer	前向地址
 * 
 */

export function productAddFavoritePoint({
  product_id,
  product_name,
  cate_id,
  cate_name,
}: {
  product_id: string;
  product_name: string;
  cate_id: string;
  cate_name: string;
}) {
  hina.track('product_add_favorite', {
    product_id,
    product_name,
    cate_id,
    cate_name,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

// 产品详情页询价 consultation_price
/* 
product_id	产品id
product_name	产品名称
cate_id	分类id
cate_name	分类名称
H_referrer_domain	前向域名
H_referrer	前向地址
belong_shop	所属商城
  product_sku_id,
    product_attr_str,
*/
export function consultationPricePoint({
  product_id,
  product_name,
  cate_id,
  cate_name,
  product_sku_id,
  product_attr_str,
}: {
  product_id: string;
  product_name: string;
  cate_id: string;
  cate_name: string;
  product_sku_id?: string;
  product_attr_str?: string;
}) {
  hina.track('consultation_price', {
    product_id,
    product_name,
    cate_id,
    cate_name,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
    product_sku_id,
    product_attr_str,
  });
}

// 加入购物车 header_cart_click
/* 
H_url_path	页面路径
inlet	入口 1: 首页搜索栏旁的购物车，2：首页个人信息下面的我的购物车 3：web右侧栏的购物车

*/

export function headerCartClickPoint({ inlet }: { inlet: number }) {
  hina.track('header_cart_click', {
    H_url_path,
    inlet,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

/* // 首页积分模块进入 home_point_enter 
belong_shop	所属商城
H_url_path	页面路径
inlet	入口

*/

export function homePointEnterPoint({ point_inlet }: { point_inlet: number }) {
  hina.track('home_point_enter', {
    H_url_path,
    point_inlet,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

/* 
首页热门推荐 home_hot_recommend

belong_shop	所属商城
H_url_path	页面路径
product_id	产品id
product_name	产品名称
product_price	产品价格
cate_id	分类id
cate_name	分类名称
*/

export function homeHotRecommendPoint({
  product_id,
  product_name,
  product_price,
  cate_id,
  cate_name,
}: {
  product_id: string;
  product_name: string;
  product_price: number;
  cate_id: string;
  cate_name: string;
}) {
  hina.track('home_hot_recommend', {
    H_url_path,
    product_id,
    product_name,
    product_price,
    cate_id,
    cate_name,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

/* 

首页新品推荐 home_new_recommend
 belong_shop	所属商城
H_url_path	页面路径
product_price	产品价格
product_id	产品id
product_name	产品名称
*/

export function homeNewRecommendPoint({
  product_id,
  product_name,
  product_price,
}: {
  product_id: string;
  product_name: string;
  product_price: number;
}) {
  hina.track('home_new_recommend', {
    H_url_path,
    product_id,
    product_name,
    product_price,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

/* 首页为你推荐 home_recommend
belong_shop	所属商城
H_url_path	页面路径
product_price	产品价格
product_id	产品id
product_name	产品名称
*/

export function homeRecommendPoint({
  product_id,
  product_name,
  product_price,
}: {
  product_id: string;
  product_name: string;
  product_price: number;
}) {
  hina.track('home_recommend', {
    H_url_path,
    product_id,
    product_name,
    product_price,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

/* 
home_package_click
首页套餐点击
belong_shop	所属商城
H_url_path	页面路径
package_id	套餐id
package_name	套餐名称
*/

export function homePackageClickPoint({
  package_id,
  package_name,
  package_inlet,
}: {
  package_id?: string;
  package_name?: string;
  package_inlet: number;
}) {
  hina.track('home_package_click', {
    H_url_path,
    package_id,
    package_name,
    belong_shop: appInfo().pointShopName,
    package_inlet,
    H_referrer,
    H_referrer_domain,
  });
}

/**
 * 品牌搜索关键词
brand_search_word

belong_shop	所属商城
H_url_path	页面路径
search_word	搜索关键词
search_total	搜索返回结果数
* 
*/

export function brandSearchWordPoint({ search_word, search_total }: { search_word: string; search_total: number }) {
  hina.track('brand_search_word', {
    H_url_path,
    search_word,
    search_total,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

/* 
brand_list_click

品牌列表点击
belong_shop	所属商城
H_url_path	页面路径
brand_id	品牌id
brand_name	品牌名称

*/

export function brandListClickPoint({ brand_id, brand_name }: { brand_id: string; brand_name: string }) {
  hina.track('brand_list_click', {
    H_url_path,
    brand_id,
    brand_name,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

/**
 * package_activity_click
套餐活动点击

belong_shop	所属商城
H_url_path	页面路径

 * 
 * 
 */
export function packageActivityClickPoint() {
  hina.track('package_activity_click', {
    H_url_path,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
  });
}

/**
 * enter_brand_click
 * 品牌专区点击
 * belong_shop	所属商城
H_url_path	页面路径
brand_inlet	品牌入口
 * 
 */
export function enterBrandClickPoint({ brand_inlet }: { brand_inlet: number }) {
  hina.track('enter_brand_click', {
    H_url_path,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
    brand_inlet,
  });
}

/**
 * enter_packgae_list
进入套餐列表
belong_shop	所属商城
H_url_path	页面路径
package_list_inlet	套餐列表入口
 * 
 * 
 */

export function enterPackgaeListPoint({ package_list_inlet }: { package_list_inlet: number }) {
  hina.track('enter_packgae_list', {
    H_url_path,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
    package_list_inlet,
  });
}
/* 
  order_pay
订单支付
（备注：微信支付后端埋点，
赊销为提交订单前端埋点，
线下支付后台前端埋点）

order_id	订单id
order_sn	订单编号
product_id	商品id
product_name	商品名称
product_brand	商品品牌名称
product_quantity	购买数量
product_sku_id	商品sku编号
cate_id	商品分类id
cate_name	分类名称
supplier_company_id	供方公司id
supplier_company_name	供方公司名称
product_attr	商品销售属性
zone_id	专区id
host_id	主体商城
total_amount	订单项金额
actual_amount	实付金额
use_points	下单时使用的积分
order_type	订单类型:pc,applet
order_total_amount	订单应付金额
order_pay_amount	订单实付金额
order_points_amout	积分抵扣金额
order_freight_amount	订单运费金额
status	订单子项状态
pay_type	支付方式
order_status	订单状态

*/
export function orderPayPoint({
  order_id,
  order_sn,
  product_id,
  product_name,
  product_brand,
  product_quantity,
  product_sku_id,
  cate_id,
  cate_name,
  supplier_company_id,
  supplier_company_name,
  product_attr,
  product_attr_str,
  zone_id,
  host_id,
  total_amount,
  actual_amount,
  use_points,
  order_type,
  order_total_amount,
  order_pay_amount,
  order_points_amout,
  order_freight_amount,
  status,
  pay_type,
  order_status,
  order_item_id,
}: {
  order_id: string;
  order_sn: string;
  product_id: string;
  product_name: string;
  product_brand: string;
  product_quantity: number;
  product_sku_id: string;
  cate_id: string;
  cate_name: string;
  supplier_company_id: string;
  supplier_company_name: string;
  product_attr: string;
  product_attr_str: string;
  zone_id: string;
  host_id: string;
  total_amount: number;
  actual_amount: number;
  use_points: number;
  order_type: string;
  order_total_amount: number;
  order_pay_amount: number;
  order_points_amout: number;
  order_freight_amount: number;
  status: string;
  pay_type: string;
  order_status: string;
  order_item_id: string;
}) {
  hina.track('order_pay', {
    order_id,
    order_sn,
    product_id,
    product_name,
    product_brand,
    product_quantity,
    product_sku_id,
    cate_id,
    cate_name,
    supplier_company_id,
    supplier_company_name,
    product_attr,
    product_attr_str,
    zone_id,
    host_id,
    total_amount,
    actual_amount,
    use_points,
    order_type,
    order_total_amount,
    order_pay_amount,
    order_points_amout,
    order_freight_amount,
    status,
    pay_type,
    order_status,
    belong_shop: appInfo().pointShopName,
    H_referrer,
    H_referrer_domain,
    order_item_id,
  });
}

/**
 * 前台申请售后
 * order_apply_after_sale
 * belong_shop	所属商城
H_url_path	页面路径
order_id	订单id
order_sn	订单编号
product_id	产品id
product_name	产品名称
product_sku_id	产品skuid
product_attr_str	产品属性
after_sale_type	售后类型
product_count	申请数量
description	申请原因
status	订单子项状态
address_id	地址id
address	详细地址
host_id	商城主体
zone_id	活动id
order_status	订单状态
 * 
 * 
 */

export function orderApplyAfterSalePoint({
  order_id,
  order_sn,
  product_id,
  product_name,
  product_sku_id,
  product_attr_str,
  after_sale_type,
  product_count,
  description,
  status,
  address_id,
  address,
  host_id,
  zone_id,
  order_status,
  order_item_id,
  total_amount,
}: {
  order_id: string;
  order_sn: string;
  product_id: string;
  product_name: string;
  product_sku_id: string;
  product_attr_str: string;
  after_sale_type: string;
  product_count: number;
  description: string;
  status: string;
  address_id: string;
  address: string;
  host_id: string;
  zone_id: string;
  order_status: string;
  order_item_id: string;
  total_amount: number;
}) {
  hina.track('order_apply_after_sale', {
    order_id,
    order_sn,
    product_id,
    product_name,
    product_sku_id,
    product_attr_str,
    after_sale_type,
    product_count,
    description,
    status,
    address_id,
    address,
    host_id,
    zone_id,
    order_status,
    belong_shop: getShopName(host_id, zone_id),
    H_referrer,
    H_referrer_domain,
    H_url_path,
    order_item_id,
    total_amount,
  });
}

/**
 * order_confirm_shop
 *
 * 订单确认收货（备注：根据子项来上报数据，
后端自动确认收货上报数据。）
belong_shop	所属商城
H_url_path	页面路径
order_id	订单id
order_sn	订单编号
product_id	产品id
product_name	产品名称
product_sku_id	产品skuid
product_attr_str	产品属性
status	订单子项状态
zone_id	专区id
host_id	主题商城
total_amount	订单项金额
actual_amount	实付金额
use_points	下单时使用的积分
order_type	订单类型:pc,applet
order_total_amount	订单应付金额
order_pay_amount	订单实付金额
order_points_amout	积分抵扣金额
order_freight_amount	订单运费金额
order_status	订单状态
 */

export function orderConfirmShopPoint({
  order_id,
  order_sn,
  product_id,
  product_name,
  product_sku_id,
  product_attr_str,
  status,
  zone_id,
  host_id,
  total_amount,
  actual_amount,
  use_points,
  order_type,
  order_total_amount,
  order_pay_amount,
  order_points_amout,
  order_freight_amount,
  order_status,
  order_item_id,
}: {
  order_id: string;
  order_sn: string;
  product_id: string;
  product_name: string;
  product_sku_id: string;
  product_attr_str: string;
  status: string;
  zone_id: string;
  host_id: string;
  total_amount: number;
  actual_amount: number;
  use_points: number;
  order_type: string;
  order_total_amount: number;
  order_pay_amount: number;
  order_points_amout: number;
  order_freight_amount: number;
  order_status: string;
  order_item_id: string;
}) {
  hina.track('order_confirm_shop', {
    order_id,
    order_sn,
    product_id,
    product_name,
    product_sku_id,
    product_attr_str,
    status,
    zone_id,
    host_id,
    total_amount,
    actual_amount,
    use_points,
    order_type,
    order_total_amount,
    order_pay_amount,
    order_points_amout,
    order_freight_amount,
    order_status,
    belong_shop: getShopName(host_id, zone_id),
    H_referrer,
    H_referrer_domain,
    H_url_path,
    order_item_id,
  });
}

/**
 *  order_cancle
 * 订单取消
(1、前台埋点
2、后台自动取消订单)

belong_shop	所属商城	VARCHAR
H_url_path	页面路径	VARCHAR
order_id	订单id	VARCHAR
order_sn	订单编号	VARCHAR
status	订单状态	VARCHAR
product_id	商品id	VARCHAR
product_name	商品名称	VARCHAR
product_brand	商品品牌名称	VARCHAR
product_quantity	购买数量	VARCHAR
product_sku_id	商品sku编号	VARCHAR
product_category_id	商品分类id	VARCHAR
supplier_company_id	供方公司id	VARCHAR
supplier_company_name	供方公司名称	VARCHAR
product_attr	商品销售属性	VARCHAR
zone_id	专区id	VARCHAR
host_id	主题商城	VARCHAR
total_amount	订单项金额	VARCHAR
actual_amount	实付金额	VARCHAR
use_points	下单时使用的积分	VARCHAR
order_type	订单类型:pc,applet	VARCHAR
order_total_amount	订单应付金额	VARCHAR
order_pay_amount	订单实付金额	VARCHAR
order_points_amout	积分抵扣金额	VARCHAR
order_freight_amount	订单运费金额	VARCHAR
order_status	订单状态	VARCHAR
 */

export function orderCanclePoint({
  order_id,
  order_sn,
  status,
  product_id,
  product_name,
  product_brand,
  product_quantity,
  product_sku_id,
  cate_id,
  supplier_company_id,
  supplier_company_name,
  product_attr,
  product_attr_str,
  zone_id,
  host_id,
  total_amount,
  actual_amount,
  use_points,
  order_type,
  order_total_amount,
  order_pay_amount,
  order_points_amout,
  order_freight_amount,
  order_status,
  order_item_id,
}: {
  order_id: string;
  order_sn: string;
  status: string;
  product_id: string;
  product_name: string;
  product_brand: string;
  product_quantity: number;
  product_sku_id: string;
  cate_id: string;
  supplier_company_id: string;
  supplier_company_name: string;
  product_attr: string;
  product_attr_str: string;
  zone_id: string;
  host_id: string;
  total_amount: number;
  actual_amount: number;
  use_points: number;
  order_type: string;
  order_total_amount: number;
  order_pay_amount: number;
  order_points_amout: number;
  order_freight_amount: number;
  order_status: string;
  order_item_id: string;
}) {
  hina.track('order_cancle', {
    order_id,
    order_sn,
    status,
    product_id,
    product_name,
    product_brand,
    product_quantity,
    product_sku_id,
    cate_id,
    supplier_company_id,
    supplier_company_name,
    product_attr,
    product_attr_str,
    zone_id,
    host_id,
    total_amount,
    actual_amount,
    use_points,
    order_type,
    order_total_amount,
    order_pay_amount,
    order_points_amout,
    order_freight_amount,
    order_status,
    belong_shop: getShopName(host_id, zone_id),
    H_referrer,
    H_referrer_domain,
    H_url_path,
    order_item_id,
  });
}

/** after_order_user_fill_delivery_info
 * （换货，退货、退货退款）
售后订单回填单号
order_id	订单id
order_sn	订单编号
status	订单子项状态
delivery_mode	配送方式
product_id	产品id
product_name	产品名称
product_sku_id	产品skuid
product_attr_str	产品属性
delivery_remark	送货备注
delivery_company	物流公司
delivery_sn	物流单号
host_id	商城主体
zone_id	活动id
order_status	订单状态
after_sale_type 售后类型
 *  
 * 
 */

export function afterOrderUserFillDeliveryInfoPoint({
  order_id,
  order_sn,
  status,
  delivery_mode,
  product_id,
  product_name,
  product_sku_id,
  product_attr_str,
  delivery_remark,
  delivery_company,
  delivery_sn,
  host_id,
  zone_id,
  order_status,
  after_sale_type,
  order_item_id,
}: {
  order_id: string;
  order_sn: string;
  status: string;
  delivery_mode: string;
  product_id: string;
  product_name: string;
  product_sku_id: string;
  product_attr_str: string;
  delivery_remark: string;
  delivery_company: string;
  delivery_sn: string;
  host_id: string;
  zone_id: string;
  order_status: string;
  after_sale_type: string;
  order_item_id: string;
}) {
  hina.track('after_order_user_fill_delivery_info', {
    order_id,
    order_sn,
    status,
    delivery_mode,
    product_id,
    product_name,
    product_sku_id,
    product_attr_str,
    delivery_remark,
    delivery_company,
    delivery_sn,
    host_id,
    zone_id,
    order_status,
    after_sale_type,
    belong_shop: getShopName(host_id, zone_id),
    H_referrer,
    H_referrer_domain,
    H_url_path,
    order_item_id,
  });
}

/**
 * after_order_confirm_delivery
 * （换货、缺货补发）
售后订单确认收货
订单只有一项时，
会直接改变订单状态

belong_shop	所属商城
H_url_path	页面路径
order_id	订单id
order_sn	订单编号
status	订单子项状态
product_id	商品id
product_name	商品名称
product_brand	商品品牌名称
product_quantity	购买数量
product_sku_id	商品sku编号
product_category_id	商品分类id
supplier_company_id	供方公司id
supplier_company_name	供方公司名称
product_attr	商品销售属性
zone_id	专区id
host_id	主题商城
total_amount	订单项金额
actual_amount	实付金额
use_points	下单时使用的积分
order_type	订单类型:pc,applet
order_total_amount	订单应付金额
order_pay_amount	订单实付金额
order_points_amout	积分抵扣金额
order_freight_amount	订单运费金额
order_status	订单状态
after_sale_type	订单售后类型
 */

export function afterOrderConfirmDeliveryPoint({
  order_id,
  order_sn,
  status,
  product_id,
  product_name,
  product_brand,
  product_quantity,
  product_sku_id,
  cate_id,
  supplier_company_id,
  supplier_company_name,
  product_attr,
  product_attr_str,
  zone_id,
  host_id,
  total_amount,
  actual_amount,
  use_points,
  order_type,
  order_total_amount,
  order_pay_amount,
  order_points_amout,
  order_freight_amount,
  order_status,
  after_sale_type,
  order_item_id,
}: {
  order_id: string;
  order_sn: string;
  status: string;
  product_id: string;
  product_name: string;
  product_brand: string;
  product_quantity: number;
  product_sku_id: string;
  cate_id: string;
  supplier_company_id: string;
  supplier_company_name: string;
  product_attr: string;
  product_attr_str: string;
  zone_id: string;
  host_id: string;
  total_amount: number;
  actual_amount: number;
  use_points: number;
  order_type: string;
  order_total_amount: number;
  order_pay_amount: number;
  order_points_amout: number;
  order_freight_amount: number;
  order_status: string;
  after_sale_type: string;
  order_item_id: string;
}) {
  hina.track('after_order_confirm_delivery', {
    order_id,
    order_sn,
    status,
    product_id,
    product_name,
    product_brand,
    product_quantity,
    product_sku_id,
    cate_id,
    supplier_company_id,
    supplier_company_name,
    product_attr,
    product_attr_str,
    zone_id,
    host_id,
    total_amount,
    actual_amount,
    use_points,
    order_type,
    order_total_amount,
    order_pay_amount,
    order_points_amout,
    order_freight_amount,
    order_status,
    after_sale_type,
    belong_shop: getShopName(host_id, zone_id),
    H_referrer,
    H_referrer_domain,
    H_url_path,
    order_item_id,
  });
}

export function productPoint({
  host_id,
  zone_id,
  cate_id,
  cate_name,
  brand_id,
  brand_name,
  supplier_company_id,
  supplier_company_name,
  product_sku_id,
  product_attr_str,
  product_template_id,
  product_template_name,
  event_scene,
  product_id,
  product_name,
}: {
  host_id: string;
  zone_id: string;
  cate_id: string;
  cate_name: string;
  brand_id: string;
  brand_name: string;
  supplier_company_id: string;
  supplier_company_name: string;
  product_sku_id: string;
  product_attr_str: string;
  product_template_id: string;
  product_template_name: string;
  event_scene: string;
  product_id: string;
  product_name: string;
}) {
  hina.track('product_info', {
    host_id,
    zone_id,
    cate_id,
    cate_name,
    brand_id,
    brand_name,
    supplier_company_id,
    supplier_company_name,
    product_sku_id,
    product_attr_str,
    product_template_id,
    product_template_name,
    event_scene,
    product_id,
    product_name,
    H_referrer,
    H_referrer_domain,
  });
}

export function activeClickEnter({ belong_shop, active_inlet }: { belong_shop?: string; active_inlet: number }) {
  hina.track('active_enter', {
    belong_shop: appInfo().pointShopName,
    active_inlet,
  });
}

//  active_page_detail
export function activePageDetail() {
  hina.track('active_page_detail');
}
